import { TenantInfo } from "../models/tenant.model";

export enum TenantSwitchingActionType {
  SET_AVAILABLE_TENANTS = "[TenantSwitching] Set Available Tenants",
  SET_SELECTED_TENANT = "[TenantSwitching] Set Selected Tenant",
  SET_LOADING = "[TenantSwitching] Set Loading",
  SET_ERROR = "[TenantSwitching] Set Error",
  CLEAR_ERROR = "[TenantSwitching] Clear Error",
  SET_SWITCHING = "[TenantSwitching] Set Switching",
  CLEAR_TENANTS = "[TenantSwitching] Clear Tenants"
}

export interface SetAvailableTenantsAction {
  type: TenantSwitchingActionType.SET_AVAILABLE_TENANTS;
  payload: TenantInfo[];
}

export interface SetSelectedTenantAction {
  type: TenantSwitchingActionType.SET_SELECTED_TENANT;
  payload: string | null;
}

export interface SetTenantSwitchingLoadingAction {
  type: TenantSwitchingActionType.SET_LOADING;
  payload: boolean;
}

export interface SetErrorAction {
  type: TenantSwitchingActionType.SET_ERROR;
  payload: string;
}

export interface ClearErrorAction {
  type: TenantSwitchingActionType.CLEAR_ERROR;
}

export interface SetSwitchingAction {
  type: TenantSwitchingActionType.SET_SWITCHING;
  payload: boolean;
}

export interface ClearTenantsAction {
  type: TenantSwitchingActionType.CLEAR_TENANTS;
}

export type TenantSwitchingActions = 
  | SetAvailableTenantsAction
  | SetSelectedTenantAction 
  | SetTenantSwitchingLoadingAction
  | SetErrorAction
  | ClearErrorAction
  | SetSwitchingAction
  | ClearTenantsAction;

// Action creators
export function setAvailableTenants(tenants: TenantInfo[]): SetAvailableTenantsAction {
  return {
    type: TenantSwitchingActionType.SET_AVAILABLE_TENANTS,
    payload: tenants
  };
}

export function setSelectedTenant(tenantId: string | null): SetSelectedTenantAction {
  return {
    type: TenantSwitchingActionType.SET_SELECTED_TENANT,
    payload: tenantId
  };
}

export function setTenantSwitchingLoading(loading: boolean): SetTenantSwitchingLoadingAction {
  return {
    type: TenantSwitchingActionType.SET_LOADING,
    payload: loading
  };
}

export function setError(error: string): SetErrorAction {
  return {
    type: TenantSwitchingActionType.SET_ERROR,
    payload: error
  };
}

export function clearError(): ClearErrorAction {
  return {
    type: TenantSwitchingActionType.CLEAR_ERROR
  };
}

export function setSwitching(switching: boolean): SetSwitchingAction {
  return {
    type: TenantSwitchingActionType.SET_SWITCHING,
    payload: switching
  };
}

export function clearTenants(): ClearTenantsAction {
  return {
    type: TenantSwitchingActionType.CLEAR_TENANTS
  };
}
